import telematicsService from "../../api/telematics.service";
import rules from "../../utils/rules";
import moment from "moment";

export default {
  name: "specification",
  components: {},
  props: ["respData"],

  data() {
    return {
      isEditing: false,
      menu1: false,
      dialog: false,
      searchBrand: null,
      searchModel: null,
      searchCategory: null,
      isLoaderCategory: false,
      isLoaderBrand: false,
      isLoaderModel: false,
      valid: true,
      rules: rules,
      loadings: false,
      selectedModel: "",
      selectedBrand: "",
      selectedCategory: "",
      selectedExternalReference: "",
      selectedName: "",
      selectedVin: "",
      selectedProductionDate: "",
      OldModel: "",
      OldBrand: "",
      OldCategory: "",
      OldExternalReference: "",
      OldName: "",
      OldVin: "",
      machineId: "",
      OldProductionDate: "",
      metadata: [100],
      brands: [],
      models: [],
      unitId: "",
      assetId: "",
      categories: [],
      brandRadioInput: "2",
      categoryRadioInput: "2",
      modelRadioInput: "2",

      brandList: ["Chicago Pneumatic", "Chicago Pneumatic1"],
      typeList: ["Generator", "Generator1"],
      modelList: ["CPG 70", "CPG 71"],

      readOnlyFields: [],
      chartOptions: {
        chart: {
          width: 580,
          type: "donut",
        },
        responseData: {},
        dataLabels: {
          enabled: false,
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  showAlways: true,
                  show: true,
                },
              },
            },
          },
        },
        responsive: [
          {
            // breakpoint: 480,
            options: {
              chart: {
                width: 580,
              },
              // legend: {
              //   show: false
              // }
            },
          },
        ],
        legend: {
          position: "bottom",
          show: false,
          horizontalAlign: "left",
          verticalAlign: "center",
          fontWeight: 600,
          offsetX: 25,
        },
        colors: ["rgba(0,227,150,0.85)", "#f7cb41", "rgba(0,143,251,0.85)"],
        labels: ["Total"],
      },
      responseData: {},
      // score:''
      //   {
      //     name:"0100-3950#02",
      //     brand:"Chicago Pneumatic",
      //     type:"Generator",
      //     model:"CPG 70",
      //     productionYear:"2017",
      //     vin:"HOP103256",
      //     externalReference:"HOP103256",
      //     metaschore:"100"
      //   }
      // ,
    };
  },
  watch: {
    deep: true,
    immediate: true,
    searchBrand(val) {
      //check entered text is not undefined and enter search text is multiples of 3 characters
      if (val != undefined && val != "" && val.length % 3 == 0) {
        this.searchBrands(val);
      }
    },
    searchModel(val) {
      if (val != undefined && val != "" && val.length % 3 == 0) {
        this.searchModels(val);
      }
    },
    searchCategory(val) {
      if (val != undefined && val != "" && val.length % 3 == 0) {
        this.searchCategories(val);
      }
    },
  },
  computed: {},
  async mounted() {
    // this.trackBrands();
    // this.trackModels();
    // this.trackCategories();

    this.unitId = this.respData.id;
    this.assetId = this.$route.params.assetId;
    this.getSpecifications();
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "YYYY-MM-DD";
        return moment(value).format(format);
      } else {
        let emptydata = "";
        return emptydata;
      }
    },
  },
  methods: {
    async cancelUpdate(isedit) {
      this.isEditing = !isedit;
      this.dialog = false;
      await this.getSpecifications();
    },

    async saveSpecification() {
      try {
        this.loadings = true;
        let payload = {
          machineId: this.machineId,
          model: this.selectedModel,
          brand: this.selectedBrand,
          category: this.selectedCategory,
          productionDate: this.selectedProductionDate,
          vin: this.selectedVin,
          name: this.selectedName,
          externalReference: this.selectedExternalReference,
        };
        // if (!this.readOnlyFields.includes("brand")) {
        // payload.brand = this.selectedBrand;
        // }
        // if (!this.readOnlyFields.includes("model")) {
        // payload.model = this.selectedModel;
        // }
        // if (!this.readOnlyFields.includes("category")) {
        // payload.category = this.selectedCategory;
        // }
        // if (!this.readOnlyFields.includes("vin")) {
        // payload.category = this.selectedCategory;
        // }
        // if (!this.readOnlyFields.includes("productionDate")) {
        // payload.productionDate = this.selectedProductionDate;
        // }

        // let temp = {  machineId: this.machineId,
        //   model: this.selectedModel,
        //   brand: this.selectedBrand,
        //   category: this.selectedCategory,
        //   productionDate: this.selectedProductionDate,
        //   vin: this.selectedVin,}
        let response = await telematicsService.updateSpecification(
          this.machineId,
          payload
        );
        if (response.isSuccess) {
          this.$toast.success(response.systemMessage);

          this.loadings = false;
          this.dialog = false;
          this.isEditing = false;
          this.getSpecifications();
        } else {
          this.cancelUpdate(true);
          this.$toast.error(response.systemMessage);
        }
      } catch (error) {
        this.isLoaderCategory = false;
        this.cancelUpdate(true);
        //this.$toast.error("Unable to load the data" + error);
      }
    },
    async getSpecifications() {
      let response = await telematicsService.getSpecificationsNew(this.assetId);
      if (response.isSuccess) {
        this.responseData = response.data;
        this.readOnlyFields = this.responseData.readOnlyFields ? [] : [];
        this.machineId = this.responseData.machineId;
        this.selectedName = this.responseData.name;

        this.selectedCategory = this.responseData.category;
        this.selectedModel = this.responseData.model;
        this.selectedProductionDate = this.responseData.productionDate;
        this.selectedVin = this.responseData.vin;
        this.selectedExternalReference = this.responseData.externalReference;
        await this.searchBrands(this.responseData.brand);

        if (this.selectedBrand != null && this.selectedBrand != "") {
          // this.jobSite = item.jobSite;

          this.brandRadioInput = "1";
          if (this.brands.length != 0) {
            this.selectedBrand = this.brands.filter(
              (e) => e.name == this.responseData.brand
            )[0].name;
          } else {
            this.brandRadioInput = "2";
            this.selectedBrand = this.responseData.brand;
          }
        } else {
          this.brandRadioInput = "2";
          this.selectedBrand = this.responseData.brand;
        }
        await this.searchCategories(this.selectedCategory);
        if (this.selectedCategory != null && this.selectedCategory != "") {
          // this.jobSite = item.jobSite;

          this.categoryRadioInput = "1";
          if (this.categories.length != 0) {
            this.selectedCategory = this.categories.filter(
              (e) => e.name == this.responseData.category
            )[0].name;
          } else {
            this.categoryRadioInput = "2";
            this.selectedCategory = this.responseData.category;
          }
        } else {
          this.categoryRadioInput = "2";
          this.selectedCategory = this.responseData.category;
        }
        await this.searchModels(this.selectedModel);
        if (this.selectedModel != null && this.selectedModel != "") {
          // this.jobSite = item.jobSite;

          this.modelRadioInput = "1";
          if (this.models.length != 0) {
            this.selectedModel = this.models.filter(
              (e) => e.name == this.responseData.model
            )[0].name;
          } else {
            this.modelRadioInput = "2";
            this.selectedModel = this.responseData.model;
          }
        } else {
          this.modelRadioInput = "2";
          this.selectedModel = this.responseData.model;
        }
      }
    },
    async searchBrands(value) {
      try {
        this.isLoaderBrand = true;
        let response = await telematicsService.getBrandsSearch(value);
        if (response) {
          let finaldata = response.data.filter((e) => e.name !== "");
          this.brands = finaldata;
          this.isLoaderBrand = false;
        } else {
          this.brands = [];
          this.isLoaderBrand = false;
        }
      } catch (error) {
        this.isLoaderBrand = false;
      }
    },
    async searchModels(value) {
      try {
        this.isLoaderModel = true;
        let response = await telematicsService.getModelsSearch(value);
        if (response) {
          let finaldata = response.data.filter((e) => e.name !== "");
          this.models = finaldata;
          this.isLoaderModel = false;
        } else {
          this.models = [];
          this.isLoaderModel = false;
        }
      } catch (error) {
        this.isLoaderModel = false;
      }
    },
    async searchCategories(value) {
      try {
        this.isLoaderCategory = true;
        let response = await telematicsService.getSearchTrackCategories(value);
        if (response) {
          let finaldata = response.filter((e) => e.name !== "");
          this.categories = finaldata;
          this.isLoaderCategory = false;
        } else {
          this.categories = [];
          this.isLoaderCategory = false;
        }
      } catch (error) {
        this.isLoaderCategory = false;
      }
    },
  },
};
